import { plainToClass } from 'class-transformer';
import {
  API_APPOINTMENT_TYPE_CREATE,
  API_APPOINTMENT_TYPE_DELETE,
  API_APPOINTMENT_TYPE_FIND_ALL,
  API_APPOINTMENT_TYPE_FIND_ONE,
  API_APPOINTMENT_TYPE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { AppointmentTypeDto } from '../dto';
import { FindAllResponse } from '../types';

export class AppointmentTypeApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<AppointmentTypeDto>> {
    return this.httpClient
      .get(API_APPOINTMENT_TYPE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(AppointmentTypeDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<AppointmentTypeDto> {
    return this.httpClient
      .get(API_APPOINTMENT_TYPE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(AppointmentTypeDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<AppointmentTypeDto> {
    return this.httpClient
      .post(API_APPOINTMENT_TYPE_CREATE, data)
      .then(({ data }) => {
        return plainToClass(AppointmentTypeDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<AppointmentTypeDto> {
    return this.httpClient
      .put(API_APPOINTMENT_TYPE_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(AppointmentTypeDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_APPOINTMENT_TYPE_DELETE, {
      pathParams: { uuid }
    });
  }
}
